import { unplacedFigures, type QuestionFigure } from '@padcanvas/shared';
import { ImageViewer } from '../components/ImageViewer';

interface QuestionFiguresProps {
  /** The text the figures belong to — figures it places by marker are skipped. */
  text: string | null | undefined;
  figures: readonly QuestionFigure[] | null | undefined;
  /** Applied to each image, so a caller's figures match its trailing diagram. */
  className?: string;
}

/**
 * The figures `text` does not place, shown after it — where a question's
 * `questionDiagramUrl` has always gone. Renders nothing when every figure is
 * placed. Placed figures render inside `LatexText`.
 * See docs/FeatureDesigns/question-rendering/question-figures-target.md.
 */
export default function QuestionFigures({ text, figures, className }: QuestionFiguresProps) {
  const rest = unplacedFigures(text, figures);
  if (rest.length === 0) return null;
  return (
    <>
      {rest.map(f => (
        <ImageViewer key={f.id} src={f.url} alt={f.alt || `Figure ${f.id}`} className={className} />
      ))}
    </>
  );
}
